import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { IBreadcrumb } from "../../core/models/common";
import { BreadcrumbService } from "../../core/services/breadcrumb.service";
import { MaterialModule } from "../../core/shared/material.module";
import { SharedComponents } from "../shared.module";

/**
 * Component for displaying a breadcrumb navigation bar.
 * Breadcrumbs provide users with a navigational trail to indicate their current location within the application.
 */
@Component({
  selector: "app-breadcrumb",
  standalone: true,
  imports: [CommonModule, MaterialModule, ...SharedComponents],
  templateUrl: "./breadcrumb.component.html",
  styleUrl: "./breadcrumb.component.scss",
})
export class BreadcrumbComponent {
  @Input()
  data: any = [];

  @Input()
  isAgentic: boolean = false;

  @Input()
  separator: string = '|';

  /**
   * Creates an instance of BreadcrumbComponent.
   * @param {BreadcrumbService} breadcrumbService - The service used for handling breadcrumb actions such as clicks.
   */
  constructor(private readonly breadcrumbService: BreadcrumbService) {}

  /**
   * Handles click events on breadcrumb nodes.
   * Invokes the `fireClickAction` method in the `BreadcrumbService` with the clicked node as an argument.
   * @param {IBreadcrumb} node - The breadcrumb node that was clicked.
   */
  nodeClick(node: IBreadcrumb) {
    this.breadcrumbService.fireClickAction(node);
  }

  /** Called when the user picks an item from a dropdown breadcrumb node. */
  onDropdownSelect(node: IBreadcrumb, option: { label: string; value: string }) {
    this.breadcrumbService.fireDropdownChange(node.key, option.value);
  }
}
